<div>
  <button matTooltip="Copiar" ngxClipboard [cbContent]="value" tabindex="0">
    <i class="fa fa-clone"></i>
  </button>
</div>
